<template>
  <modal :name="name" :adaptive="true" :width="640" :minWidth="300" height="auto" :scrollable="true" v-on:closed="onClosed">
    <div class="modal-content pricing-dialog">
      <div class="modal-header">
        <button type="button" class="close" :aria-label="_('Close')" v-on:click="close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{{ title }}</h4>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default pull-left" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
        <slot name="actions"></slot>
      </div>
    </div>
  </modal>
</template>

<script>
let dialogSeq = 0

// The dialog of the price calendars: the date dialog and the weekly dialogs of both editors look the
// same. The body has an optional note (.pcs-form-note), compact toggle rows (.pcs-inline-field)
// and sections (.pcs-form-section) of fields in two columns; Close is on the left of the footer and
// the editor's buttons (actions) on the right.
export default {
  props: {
    title: { type: String, default: '' }
  },
  emits: ['closed'],
  data () {
    return {
      name: 'pricing-dialog-' + (++dialogSeq),
      isOpen: false
    }
  },
  methods: {
    open () {
      this.isOpen = true
      this.$modal.show(this.name)
    },
    close () {
      if (this.isOpen) {
        this.$modal.hide(this.name)
      }
    },
    onClosed () {
      this.isOpen = false
      this.$emit('closed')
    }
  },
  beforeUnmount () {
    this.close()
  }
}
</script>

<style scoped>
.pricing-dialog {
  border: 0;
  box-shadow: none
}
.pricing-dialog .modal-body {
  max-height: calc(100dvh - 160px);
  overflow-y: auto
}
.pricing-dialog :deep(.pcs-form-note) {
  margin: 0 0 12px;
  padding: 8px 10px;
  background: #f3f6f9;
  border-radius: 4px;
  color: #555
}
.pricing-dialog :deep(.pcs-form-section) {
  margin: 16px 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  font-weight: 600;
  color: #555
}
.pricing-dialog :deep(.pcs-form-section:first-child) {
  margin-top: 0
}
/* Compact rows of toggles (weekdays, durations, start times): the label on the left */
.pricing-dialog :deep(.pcs-inline-field) {
  display: flex;
  align-items: flex-start;
  gap: 4px 12px;
  margin-bottom: 10px
}
.pricing-dialog :deep(.pcs-inline-field > label) {
  flex: 0 0 96px;
  margin: 0;
  line-height: 30px
}
.pricing-dialog :deep(.pcs-toggles) {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0
}
.pricing-dialog :deep(.pcs-toggles .btn) {
  min-width: 40px;
  font-variant-numeric: tabular-nums
}
.pricing-dialog :deep(.help-block) {
  margin-top: 2px
}
@media (max-width: 480px) {
  .pricing-dialog :deep(.pcs-inline-field) {
    flex-direction: column
  }
  .pricing-dialog :deep(.pcs-inline-field > label) {
    flex-basis: auto;
    line-height: inherit
  }
}
/* Fields in three columns on a page fit the dialog in two */
@media (min-width: 768px) {
  .pricing-dialog :deep(.row > .col-sm-4) {
    width: 50%
  }
}
.pricing-dialog :deep(.restriction-datepicker) {
  display: block;
  width: 100%
}
.pricing-dialog :deep(.restriction-datepicker .dp__main),
.pricing-dialog :deep(.restriction-datepicker .dp__input_wrap),
.pricing-dialog :deep(.restriction-datepicker .dp__input),
.pricing-dialog :deep(.restriction-datepicker .form-control) {
  width: 100%;
  max-width: none
}
</style>
